import React from 'react'
import PropTypes from 'prop-types'
import { useGetCommoditiesLazyQuery } from 'services/commodities'
import AsyncAutocomplete from '.'

const CommodityAutocomplete = ({ name, control, defaultValue, freeSolo, ...restProps }) => (
  <AsyncAutocomplete
    name={name}
    control={control}
    defaultValue={defaultValue}
    labelKey="name"
    useGetOptionsLazyQuery={useGetCommoditiesLazyQuery}
    autoSelect
    freeSolo={freeSolo}
    {...restProps}
  />
)

CommodityAutocomplete.propTypes = {
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
  defaultValue: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    code: PropTypes.string,
  }),
  freeSolo: PropTypes.bool,
  control: PropTypes.instanceOf(Object).isRequired,
}

CommodityAutocomplete.defaultProps = {
  variant: 'standard',
  defaultValue: null,
  freeSolo: true,
}

export default CommodityAutocomplete
